import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import About from "./pages/AboutSimple";
import Contact from "./pages/ContactSimple";
import Home from "./pages/HomeSimple";
import Industries from "./pages/IndustriesSimple";
import Legal from "./pages/LegalSimple";
import Manufacturing from "./pages/ManufacturingSimple";
import ProductDetail from "./pages/ProductDetailSimple";
import Products from "./pages/ProductsSimple";

export default function App() {
  return <BrowserRouter><Routes><Route element={<Layout />}><Route path="/" element={<Home />} /><Route path="/about" element={<About />} /><Route path="/products" element={<Products />} /><Route path="/products/:slug" element={<ProductDetail />} /><Route path="/manufacturing" element={<Manufacturing />} /><Route path="/industries" element={<Industries />} /><Route path="/contact" element={<Contact />} /><Route path="/privacy" element={<Legal kind="privacy" />} /><Route path="/terms" element={<Legal kind="terms" />} /><Route path="*" element={<Navigate to="/" replace />} /></Route></Routes></BrowserRouter>;
}
